import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d57618"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_2 = ["stroke", "fill"]
const _hoisted_3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "9",
  r: "9",
  fill: "#01893D"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.4301 10.931L5.62503 9.20711L4.5 10.2949L7.43257 13.0148L13.5 6.48734L12.3646 5.39941L7.4301 10.931Z",
  fill: "white"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { PropType, Ref, onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'circularProgress',
  props: {
  percent: {
    type: Number as PropType<number>,
    default: 99,
  },
},
  setup(__props) {

const props = __props;



const offset: Ref = ref(0);

watch(
  () => props.percent,
  (val) => {
    onChange(val);
  },
);

onMounted(() => {
  onChange(props.percent);
});
const onChange = (val) => {
  let inpVal: number = !val ? 0 : val;
  inpVal = Math.max(0, Math.min(100, inpVal));
  offset.value = 519 + (47 / 100) * (100 - inpVal);
};

return (_ctx: any,_cache: any) => {
  return (__props.percent < 100)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("circle", {
          cx: "8.99971",
          cy: "8.99971",
          r: "7.49971",
          stroke: __props.percent <= 0 ? '#EEEFF0' : '#DBDBDB',
          "stroke-width": "3",
          "stroke-dasharray": "565.48",
          "stroke-dashoffset": "0",
          fill: __props.percent <= 0 ? '#EEEFF0' : undefined
        }, null, 8, _hoisted_2),
        _createElementVNode("circle", {
          cx: "8.99971",
          cy: "8.99971",
          r: "7.49971",
          stroke: "#48A0FF",
          "stroke-width": "3",
          "stroke-dasharray": "565.48",
          "stroke-dashoffset": "0",
          style: _normalizeStyle(`stroke-dashoffset: ${offset.value}`)
        }, null, 4)
      ]))
    : (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
}
}

})